// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class InsertChar {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): InsertChar {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsInsertChar(bb: flatbuffers.ByteBuffer, obj?: InsertChar): InsertChar {
    return (obj || new InsertChar()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsInsertChar(bb: flatbuffers.ByteBuffer, obj?: InsertChar): InsertChar {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new InsertChar()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  location(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  unicodeScalar(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startInsertChar(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addLocation(builder: flatbuffers.Builder, locationOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, locationOffset, 0)
  }

  static addUnicodeScalar(builder: flatbuffers.Builder, unicodeScalar: number) {
    builder.addFieldInt32(1, unicodeScalar, 0)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, textFieldOffset, 0)
  }

  static endInsertChar(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
